/* eslint-disable eqeqeq */
import React, { useEffect } from "react";
import Select from "react-select";
import { differenceInDays } from "date-fns";
import { Button, Col, Row } from "react-bootstrap";

import {
  tabsName,
  starRatingConstants,
  starRatingDefaultResponse,
  conversionRateTabFilterOptions,
  inboxConversationTabFilterOptions,
  MENU_PLACEMENT,
  FILTER_LABEL,
} from "../../constants";
import { Option, ValueContainer } from "../../../../shared";
import CustomDateFilter from "../../../../shared/components/dateFilter/customDateFilter";

//Extract required properties using destructuring
const { minStarRatingVal, maxStarRatingVal } = starRatingConstants;

//Changing default style of options in react select
const customStyle = {
  option: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isDisabled ? "gray" : "black",
    backgroundColor: state.isSelected ? "transparent" : "auto",
  }),
};

const Filter = (props) => {
  //You can Extract any data OR Function that this component receive as PROPS
  const {
    activeTab,
    dateState,
    setMaxStar,
    setMinStar,
    setDateState,
    setDayCounts,
    selectedFilter,
    selectedOption,
    setSelectedFilter,
    setSelectedOption,
    onRefreshButtonClick,
  } = props;

  //Set Filter Value for star rating filter.
  const handleStarRatingFilterChange = (selectedItems) => {
    const maxSet = new Set();
    const minSet = new Set();

    if (activeTab === tabsName.starRating) {
      selectedItems.forEach((item) => {
        maxSet.add(item.maxStar);
        minSet.add(item.minStar);
      });

      setMaxStar([...maxSet]);
      setMinStar([...minSet]);
    }
    // Set default values if no items are selected
    const sortedArray = selectedItems.sort((a, b) => {
      const starA = a.value;
      const starB = b.value;
      return starA - starB;
    });
    setSelectedOption({
      ...selectedOption,
      starRating: sortedArray,
    });
    if (!sortedArray.length) {
      setMaxStar([maxStarRatingVal]);
      setMinStar([minStarRatingVal]);
    }
  };

  //Getting selected days to display in column header
  useEffect(() => {
    const { startDate, endDate } = dateState;
    const daysCount = differenceInDays(endDate, startDate) + 1;
    setDayCounts(daysCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateState]);

  return (
    <div className="pt-2 mt-3">
      <Row>
        <Col lg={6} xs={12}>
          {activeTab === tabsName.starRating && (
            <Select
              isMulti
              styles={customStyle}
              name="star"
              isSearchable
              placeholder={FILTER_LABEL.ALL}
              maxMenuHeight={200}
              menuPlacement={MENU_PLACEMENT.AUTO}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              onChange={handleStarRatingFilterChange}
              getOptionLabel={(option) => option.label}
              options={starRatingDefaultResponse}
              components={{
                IndicatorSeparator: () => null,
                Option,
                ValueContainer: ValueContainer,
              }}
              className="star-ranking rounded bg-secondary bg-opacity-25 w-50"
            />
          )}
        </Col>
      </Row>

      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-4">
          <CustomDateFilter dateState={dateState} setDateState={setDateState} />
          {activeTab === tabsName.conversionRate && (
            <Select
              className="w-12rem"
              name="Filters"
              value={selectedFilter}
              options={conversionRateTabFilterOptions}
              components={{
                IndicatorSeparator: () => null,
                ValueContainer: ValueContainer,
              }}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
              getOptionLabel={(option) => option.name}
              onChange={(selectedItems) => setSelectedFilter(selectedItems)}
              maxMenuHeight={200}
              isSearchable
              isClearable={true}
              placeholder="Select filter"
              menuPlacement={MENU_PLACEMENT.AUTO}
              styles={customStyle}
            />
          )}
          {activeTab === tabsName.inboxConversationTab && (
            <Select
              className="w-12rem"
              name="Filters"
              value={selectedFilter}
              options={inboxConversationTabFilterOptions}
              components={{
                IndicatorSeparator: () => null,
                ValueContainer: ValueContainer,
              }}
              hideSelectedOptions={false}
              closeMenuOnSelect={false}
              getOptionLabel={(option) => option.name}
              onChange={(selectedItems) => setSelectedFilter(selectedItems)}
              maxMenuHeight={200}
              placeholder="Select filter"
              menuPlacement={MENU_PLACEMENT.AUTO}
              styles={customStyle}
            />
          )}
        </div>
        {(activeTab === tabsName.conversionRate ||
          activeTab === tabsName.inboxConversationTab) && (
          <div>
            <Button
              variant="dark"
              className="user-permission-button"
              onClick={onRefreshButtonClick}
            >
              Refresh
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
